export function isNumeric(obj) {
  const realStringObj = obj && obj.toString()
  return (
    !Array.isArray(obj) && realStringObj - parseFloat(realStringObj) + 1 >= 0
  )
}

export function random(min = 0, max = 1000000) {
  return Math.round(Math.random() * (max - min) + min)
}

export function parseNumber(value, allowComma = false) {
  if (value == null || value === '') return '0';
  const parsed = parseFloat(value);
  if (isNaN(parsed)) return '0';

  return allowComma ? parsed.toLocaleString() : parsed.toString();
}

